import React from "react";
import { sessionSentence } from "../../../utils/generateSummaries";

/** The whole request as one sentence, for the desktop summary column. */
const SessionSummary = ({ config, shapeName, locationLabel }) => (
  <div className="space-y-1.5">
    <p className="text-[11px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
      Your session
    </p>
    <p className="text-[15px] leading-relaxed text-muted-foreground">
      {sessionSentence({ config, shapeName, locationLabel }).map((part, i) =>
        part.strong ? (
          <span key={i} className="font-semibold text-foreground">
            {part.text}
          </span>
        ) : (
          <React.Fragment key={i}>{part.text}</React.Fragment>
        ),
      )}
    </p>
  </div>
);

export default SessionSummary;
